import { render, staticRenderFns } from "./instructor.vue?vue&type=template&id=03e3012e"
import script from "./instructor.vue?vue&type=script&lang=js"
export * from "./instructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports